var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('v-icon',[_vm._v("mdi-arrow-down-thick")]),_vm._v(" 次へ ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }